import classNames from "classnames";
import * as React from "react";
import { RowCheckMark } from "~/sharedComponents/list/ListRowDefault";
import { TeamAvatar } from "../avatar/TeamAvatar";
import { VirtListRowProps } from "../list/BaseList";
import { UserName } from "../users/UserName";
import * as styles from "./UserListRow.less";

export interface Option {
    Id?: number;
    Name?: string;
}

export type BaseResourceListRowProps<T> = VirtListRowProps<T> & {
    className?: string;
    isSelected?: boolean;
};

export const builderResourceListRow = <T extends Option>(): React.FC<BaseResourceListRowProps<T>> => {
    return ({ item, isFocused, isSelected, textForHighlight, className }) => {
        const rowStyle = classNames(className, styles.row, isFocused && [styles.focused]);

        return (
            <div className={rowStyle} title={item.Name}>
                <TeamAvatar />
                <div className={styles.info}>
                    <UserName name={item.Name} className={styles.name} textForHighlight={textForHighlight} />
                </div>
                <RowCheckMark selected={isSelected} />
            </div>
        );
    };
};
